<template>
    <div class="c-manageStatist">
        <!-- <YScroll style="height:  920px;"> -->
        <div class="c-manageStatist__top">
            <SearchTop
                v-if="hasSearch.includes(page)"
                :changeSearch="changeSearch"
                :typeNum="page === '7' ? 2 : 0"
            />
            <CardSelect v-if="page === '3'" :changeCard="changeCard" />
        </div>
        <div class="c-manageStatist__main">
            <!-- 管控平台工作台 -->
            <Manage />
            <!-- 飞行数据统计 -->
            <!-- <FlightData v-if="page === '2'" :searchTime="searchObj" /> -->
            <!-- 飞行应用统计 -->
            <!-- <FlightAppData v-if="page === '3'" :searchObj="searchObjCard" /> -->
            <!-- 结果数据统计 -->
            <!-- <ResultData v-if="page === '4'" :searchTime="searchObj" /> -->
            <!-- 事件统计 -->
            <!-- <Event v-if="page === '5'" :searchTime="searchObj" /> -->
            <!-- <AccidentReport v-if="page === '6'" :searchTime="searchObj" /> -->
            <!-- 飞行服务数据 -->
            <!-- <flightServiceData v-if="page === '7'" :searchTime="searchObj" /> -->
        </div>
        <!-- </YScroll> -->
    </div>
</template>

<script>
// import { YScroll, XScroll } from '@CommonComponent';
// import SearchTop from './common/SearchTop';
// import FlightData from './flightPage/flightData.vue';
// import FlightAppData from './flightPage/flightAppData.vue';
// import ResultData from './recordPage/resultData.vue';
import Manage from './managePage/manage.vue';
// import Event from './eventPage/event.vue';
// import CardSelect from './common/cardSelect.vue';
// import flightServiceData from './flightServiceDataPage/flightServiceData.vue';
// import AccidentReport from '@/page/backStatist/AccidentReport/AccidentReport.vue';

export default {
    components: {
        // SearchTop,
        // FlightData,
        // FlightAppData,
        // ResultData,
        // YScroll,
        // AccidentReport,
        Manage,
        // Event,
        // CardSelect,
        // flightServiceData,
    },
    data() {
        let { page } = this.$route.query;
        return {
            page: page || 5,
            searchObj: {},
            hasSearch: ['2', '3', '4', '5', '7'],
            searchObjCard: {
                activeCard: 'flyTask',
            },
            activeCard: 'flyTask',
        };
    },
    methods: {
        changeSearch(val) {
            this.searchObjCard = { ...val, activeCard: this.activeCard };
            this.searchObj = val;
            console.log('日期', this.searchObjCard);
        },
        changeCard(val) {
            this.activeCard = val;
            this.searchObjCard = { ...this.searchObj, activeCard: val };
            console.log('类型', this.searchObjCard);
        },
        searchBtn(num) {
            this.Num = num;
        },
    },
    computed: {
        // getTxt() {
        //     let { page } = this.$route.query;
        //     switch (page) {
        //         case '1':
        //             return '首页';
        //         case '2':
        //             return '飞行数据统计';
        //         case '3':
        //             return '飞行应用统计';
        //         case '4':
        //             return '结果数据统计';
        //         case '5':
        //             return '事件统计';
        //         default:
        //             return '';
        //     }
        // },
    },
};
</script>

<style lang="scss" scoped>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.c-manageStatist {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #e7e7e7;
    overflow: hidden;
    .c-manageStatist__top {
        background-color: #e7e7e7;
        // height: 60px;
        // line-height: 54px;
    }
    .c-manageStatist__main {
        // margin-top: 54px;
        position: relative;
        background-color: #e7e7e7;
        height: calc(100% - 60px - 40px);
        margin: 0;
    }
}
</style>
